import script from "./lavanderiaView.vue?vue&type=script&setup=true&lang=ts"
export * from "./lavanderiaView.vue?vue&type=script&setup=true&lang=ts"

import "./lavanderiaView.vue?vue&type=style&index=0&id=2e1b3429&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e1b3429"]])

export default __exports__